import { nonAccentVietnamese } from '@iso/lib/helpers/utility';

import emailCampaignActions from './actions';

const initialState = {
  campaigns: [],
  total: 0,
  pageSize: 10,
  totalPages: 0,
  isFetched: false,
  errorMessage: '',
  status: '',
  campaignSummary: null,
  campaignCompanies: {
    data: [],
    overview: null
  },
  campaign: null
};

export default function emailCampaignReducer(state = initialState, action) {
  switch (action.type) {
    case emailCampaignActions.SET_EMAIL_CAMPAIGNS:
      return {
        ...state,
        campaigns: action.payload.data.map(item => {
          return {
            ...item,
            keyword: `${nonAccentVietnamese(item.name)}`,
          };
        }),
        total: action.payload.total,
        pageSize: action.payload.pageSize,
        totalPages: action.payload.totalPages,
        isFetched: true,
      };
    case emailCampaignActions.SET_EMAIL_CAMPAIGN:
      return {
        ...state,
        campaign: action.payload,
        isFetched: true,
      };
    case emailCampaignActions.SET_EMAIL_CAMPAIGN_SUMMARY:
      return {
        ...state,
        campaignSummary: action.payload,
        isFetched: true,
      };
    case emailCampaignActions.CREATE_EMAIL_CAMPAIGN:
      return {
        ...state,
        campaigns: [
          {
            ...action.payload,
            keyword: `${nonAccentVietnamese(action.payload.name)}`,
          },
          ...state.campaigns,
        ],
        total: state.total + 1,
        status: 'CREATED',
        campaign: {},
      };
    case emailCampaignActions.UPDATE_EMAIL_CAMPAIGN:
      return {
        ...state,
        campaigns: [
          ...state.campaigns.map(campaign => {
            return campaign.id === action.payload.id ? {
              ...campaign,
              ...action.payload,
              keyword: `${nonAccentVietnamese(action.payload.name)}`,
            } : campaign;
          })
        ],
        status: 'UPDATED',
      };
    case emailCampaignActions.DELETE_EMAIL_CAMPAIGN:
      return {
        ...state,
        campaigns: state.campaigns.filter(campaign => campaign.id !== action.payload.id),
        total: state.total - 1,
        status: 'DELETED',
      };
    case emailCampaignActions.EMAIL_CAMPAIGN_ERROR:
      return {
        ...state,
        errorMessage: action.payload,
        isFetched: true,
      };

    case emailCampaignActions.RESET_EMAIL_CAMPAIGN_STATUS:
      return {
        ...state,
        errorMessage: '',
        status: '',
      };
    case emailCampaignActions.SET_EMAIL_CAMPAIGN_COMPANIES:
      return {
        ...state,
        campaignCompanies: {
          data: action.payload.data,
          overview: action.payload.overview
        },
        isFetched: true,
      };
    case emailCampaignActions.REFRESH_EMAIL_CAMPAIGN_STATS:
      return {
        ...state,
        campaign: action.payload,
        campaigns: state.campaigns.map(campaign =>
          campaign.id === action.payload.id ? action.payload : campaign
        ),
        isFetched: true,
      };
    default:
      return state;
  }
}
